<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      {{ this.$string.sidebar.menu_5.sub_menu.menu_9 }}
      <CButton color="info" class="btn-md ml-auto mr-2" style="display:none">Ekspor Excel</CButton>      
      <CButton
        color="success"        
        class="btn-md ml-auto"
        @click="createData()"
      >Tambah</CButton>
    </CCardHeader>
    <!-- Data BPK -->
    <CCardBody>
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" id @change="pilihDataPerhalaman($event)">
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="100">100</option>
              <option value="1000000000000">Semua Data</option>
            </select>
          </div>
        </div>
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input type="text" id class="form-control" placeholder="Cari Data ..." v-model="searchSignature"/>
          </div>
        </div>
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #signature="{item}">
              <td>           
                <button @click="bukaFile(item.signature)" :class="item.signature == '' ? 'btn btn-secondary p-0 px-3 shadow mx-auto' : 'btn btn-success p-0 px-3 shadow mx-auto'" :disabled="item.signature == '' || item.signature == null">
                  {{ item.signature ? 'Lihat file' : 'File tidak ada' }}
                </button>                
              </td>              
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <i class="fa fa-check text-success" aria-hidden="true" v-if="item.status == 1"></i>
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2">
                <CButton
                  v-c-tooltip="'Ubah'"
                  color="info"
                  class="btn-sm text-white"
                  square
                  @click="updateData(item, index)"
                >
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          
          <CPagination
            style="float:right"
            :active-page.sync="currentPageSignature"
            :pages="pagination.totalPages"
            responsive
            @change="pageChange"
          />
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow v-on:submit.prevent="postData">
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Nama"
                placeholder="Masukkan Nama Mitra"
                v-model="formData.nama"
              />
            </CCol>
            <CCol sm="12">
              <CInput
                class="font-weight-bold"
                label="Jabatan"
                placeholder="Masukkan Jabatan"
                v-model="formData.jabatan"
              />
            </CCol>
            <CCol sm="12 mb-3">
              <label for="uid-zwqayuopq3" class="font-weight-bold">
                {{ this.$string.sidebar.menu_5.sub_menu.menu_9 }}
              </label>
              <br />
              <div class="custom-file text-truncate">
                <input
                  type="file"
                  class="custom-file-input"
                  id=""
                  :required="actionPost == 'update'"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label"
                  for=""
                  data-browse="Unggah"
                >{{ typeof formData.signature === "string" ? formData.signature : fileName }}</label>
              </div>
              <small class="text-danger">(*File harus bertipe png max. 10MB)</small>
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    value="1"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Tambah</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import SignatureService from "@/services/pelatihan/signature.service";
import { AlertUtils } from "@/mixins/AlertUtils";
import Utils from "@/services/utils.service";
import BaseUrl from "@/services/base-url";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "jabatan",
    label: "Jabatan",
    sorter: true,
    filter: false
  },
  {
    key: "signature",
    label: "Tanda Tangan",
    sorter: true,
    filter: false
  },
  {
    key: "status",
    _style: "text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 11%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils],
  data() {
    return {
      items: [],
      BaseUrl: '',
      actionPost: "",
      pageSize : '',
      formData: {
        nama: "",
        jabatan: "",
        signature: "",
        status: "",
        idSignature: ""
      },

      pagination: {
        totalPages: 0
      },
      title: "",
      searchSignature: "",
      fileName: "Pilih File",
      fields,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      currentPageSignature: 0,
      content: []
    };
  },
  mounted() {
    this.getData('0','10','default');
    this.baseUrl = BaseUrl();
  },
  watch: {
    searchSignature: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {          
        vm.getData("0", vm.pageSize, vm.searchSignature);
      }, 1000);
    },
    
    currentPageSignature: function(val) {      
      var page = val - 1;
      this.indexed = page * 10;      
      this.getData(val - 1, this.pageSize, this.searchPetugas);      
    }
  },
  methods: {
    pilihDataPerhalaman(e) {
      this.pageSize = e.target.value
      this.getData(0,e.target.value,this.searchPetugas);
    },
    pageChange() {
      this.getData(currentPage);
    },

    deleteData(item, index) {
      var vm = this;

      vm.formData = item;
      vm.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            SignatureService.deleteSignature(vm.formData)
              .then(response => {
                // comment console console.log(response);
                vm.alertSuccess();
                vm.getData(0);
              })
              .catch(error => {
                vm.alertError();
                // comment console console.log(error)
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, searchSignature) {
      var vm = this;
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      SignatureService.getSignature(currentPage,pageSize,searchSignature)
        .then(response => {
          // comment console console.log(response.data.content)
          vm.items = response.data.content;          

          vm.pagination.totalPages = response.data.totalPages;
          vm.currentPageSignature = response.data.pageable.pageNumber + 1;
          loader.hide();
        })
        .catch(error => {
          loader.hide()
          // comment console console.log(error)
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.fileName = "Pilih File",
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.fileName = "Pilih File",
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData(this.formData);
      }
    },

    insertData(formData) {

      var vm = this;

      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      var formData = this.formData;
      if (typeof formData.signature === "string") {
        delete formData.signature
      }
      if (formData.signature === null) {
        delete formData.signature
      }
      SignatureService.postSignature(formData).then(
        () => {
          vm.myModal = false;
          const Toast = vm.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            onOpen: toast => {
              loader.hide();
              toast.addEventListener("mouseenter", vm.$swal.stopTimer);
              toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
            }
          });
          Toast.fire({
            icon: "success",
            title: "Data Berhasil Ditambah"
          });
          vm.getData(0,10,'default');
        },
        error => {
         
          loader.hide();
          vm.$swal.fire({
            title: "Peringatan!",
            text: error.response.data.message,
            icon: "errorr",
            showCancelButton: true
          });
        }
      );
    },

    putData(formData) {

      var vm = this;

      // comment console console.log("put")
      // comment console console.log(formData);      
      if (typeof formData.signature === "string") {
        delete formData.signature;
      }

      if (formData.signature === null) {
        delete formData.signature;
      }

      SignatureService.putSignature(formData)
        .then(response => {
          vm.myModal = false;

          vm.alertSuccess();

          vm.getData(0,10,'default');
        })
        .catch(error => {
          // comment console console.log(error);

          vm.alertError(error.response.data.message);
        });
    },

    fileUpload(e) {
      this.formData.signature = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },

    bukaFile(file) {
      
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=pelatihan@signature";
        window.open(routeData, "_blank");
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },
  }
};
</script>